export const listProgramMembershipsByProgramIds = (
  programIds: string[],
  role?: string
) => /* GraphQL */ `
  query ListProgramMembershipsByProgramIds($nextToken: String) {
    listProgramMemberships(
      nextToken: $nextToken
      filter: {
        or: [
          ${programIds.map((pid) => `{programId: {eq: "${pid}"}}`)}
        ],
        ${role ? `and: [{programRole: {eq: ${role}}}]` : ""}
      }
    )  {
      nextToken
      items {
        id
        programRole
        programMember {
          id
          firstName
          lastName
          email
          lastName
          npi
          pgy
          eulaAcceptedDate
          institution {
            description
            name
          }
        }
        program {
          id
          name
          description
        }
      }
    }
  }
`;

export const listUserInvitationsByProgramIds = (
  programIds: string[]
) => /* GraphQL */ `
  query ListUserInvitationsByProgramIds($nextToken: String) {
    listUserInvitations(
      nextToken: $nextToken
      filter: {
        or: [
          ${programIds.map((pid) => `{programId: {eq: "${pid}"}}`)}
        ]
      }
    ) {
      nextToken
      items {
        id
        inviteeId
        invitee {
          id
          email
          emailLower
          institutionId
          institution {
            id
            name
            description
            createdAt
            updatedAt
            __typename
          }
          firstName
          lastName
          npi
          pgy
          settings {
            sendEmail
            sendPushNotifications
            __typename
          }
          lastLogin
          eulaAcceptedDate
          programMemberships {
            nextToken
            __typename
          }
          simpl1Id
          deviceToken
          devicePlatform
          createdAt
          updatedAt
          __typename
        }
        institutionId
        invitationStatus
        email
        emailLower
        adminId
        programId
        program {
          id
          name
          description
          institutionId
          institution {
            id
            name
            description
            createdAt
            updatedAt
            __typename
          }
          programMemberships {
            nextToken
            __typename
          }
          sponsors {
            nextToken
            __typename
          }
          simpl1Id
          createdAt
          updatedAt
          __typename
        }
        role
        createdAt
        updatedAt
        __typename
      }
    }
  }
`;


export const getSponsorWithoutPrograms = /* GraphQL */ `
  query GetSponsor($id: ID!) {
    getSponsor(id: $id) {
      id
      name
      description
      networks {
        items {
          id
          name
          sponsorId
          sponsor {
            id
            name
            description
            createdAt
            updatedAt
            __typename
          }
          programs {
            nextToken
            __typename
          }
          activities {
            nextToken
            __typename
          }
          simpl1Id
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      branding {
        colors {
          primary
          secondary
          light
          __typename
        }
        logos {
          fullMono
          fullColor
          squareMono
          squareColor
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;